/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSelector } from 'reselect';

const getAgentDetails = (state: any) => state.getIn(['userReducer', 'agentDetails']);
const getUserDetails = (state: any) => state.getIn(['userReducer', 'userProfileInfo']);
const getAgentCertificates = (state: any) => state.getIn(['userReducer', 'agentCertificates']);
const getAgentProfilePic = (state: any) => state.getIn(['userReducer', 'agentProfilePic']);
const getDiwaliPdf = (state: any) => state.getIn(['userReducer', 'diwaliPdfView']);
const getAum = (state: any) => state.getIn(['userReducer', 'countTotalAUM']);
const getAgentARN = (state: any) => state.getIn(['userReducer', 'isAgentARN']);
const getPaymentUrl = (state: any) => state.getIn(['userReducer', 'paymentUrl']);
const getCalcLeads = (state: any) => state.getIn(['userReducer', 'calculatorLeads']);
const orderSummaryData = (state: any) => state.getIn(['userReducer', 'orderSummaryData']);
const getIsAgentNotAllowed = (state: any) => state.getIn(['userReducer', 'isAgentNotAllowed']);

const UserSelector = createSelector(
    [getAgentDetails, getUserDetails, getAgentCertificates, getAgentProfilePic, getDiwaliPdf, getAum, getAgentARN, getPaymentUrl, getCalcLeads, orderSummaryData, getIsAgentNotAllowed],
    (agentDetails, userProfileInfo, agentCertificates, agentProfilePic, diwaliPdfView, countTotalAUM,isAgentARN,  paymentUrl, calculatorLeads, orderSummaryData,isAgentNotAllowed) => ({
        agentDetails,
        userProfileInfo,
        agentCertificates,
        agentProfilePic,
        diwaliPdfView,
        countTotalAUM,
        isAgentARN,
        paymentUrl,
        calculatorLeads,
        orderSummaryData,isAgentNotAllowed
    })
);

export default UserSelector;